export const COMMISSION_UPDATED_EVENT = "commission:updated";

export const notifyCommissionUpdated = (detail = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(COMMISSION_UPDATED_EVENT, { detail })
  );
};

export const subscribeCommissionUpdated = (handler) => {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => handler(event.detail ?? {});
  window.addEventListener(COMMISSION_UPDATED_EVENT, listener);
  return () => window.removeEventListener(COMMISSION_UPDATED_EVENT, listener);
};
